module.exports = __webpack_public_path__ + "img/image2.d8e269d7.jpg";